import $ from 'jquery'

function OpendaysPopup() {
    let incr = 0;
    $('.box-login .int-box').append($('#opendayspopup'))
    $('#opendayspopup').css('display', 'block');
    let participants = $('#participants')
    let adder = $('#add-participant')
    let form = $('#opendayspopup form')

    function increase() {
        incr++
        let str = adder.data('prototype').replace(/__name__/g, incr)
        participants.append(str)
        $('input[name="participants[' + incr + ']"][firstname]').rules("add", {required: true})
        $('input[name="participants[' + incr + ']"][lastname]').rules("add", {required: true})
    }

    function decrease() {
        $('.participant[data-increment="' + incr + '"]').remove()
        incr--
    }


    function initAjaxBoxForm(successCallback) {
        form.validate({
            focusInvalid: true,
            ignore: "",
            onfocusout: function (element) {
                setTimeout(() => $(element).valid(), 500);
            }
        })

        form.submit(function () {
            if (!form.valid())
                return false;
            let btn = form.find('button[type=submit]')
            let old = btn.text()
            btn.text(btn.data('loadingtext') ? btn.data('loadingtext') : 'Caricamento...').attr('disabled', true)
            if (form.parent().hasClass('direct'))
                return true;
            $.post(
                form.attr('action'),
                form.serialize(),
                function (data) {
                    if (data.has_error) {
                        form.find('.error-area').html('<div class="error">' + data.error + '</div>')
                        btn.text(old).attr('disabled', false)
                    } else {
                        successCallback(form, data)
                    }
                }
            );
            return false;
        });
    }

    function init() {
        let success = false
        $('#event_id').change(function () {
            let freeSeats = parseInt($('#event_id option:selected').data('seats'))
            $('#participants_count option').each(function () {
                $(this).attr('disabled', parseInt($(this).attr('value')) > freeSeats)
            });
            if (incr > freeSeats)
                $('#participants_count').val(freeSeats).change()
        })

        $('#participants_count').change(function () {
            let val = parseInt($(this).val())
            if (val > incr)
                while (val != incr)
                    increase()
            else if (val < incr)
                while (val != incr)
                    decrease()
        }).change()

        initAjaxBoxForm(function (form) {
            success = true
            form.find('.hide-on-success').hide();
            form.find('.show-on-success').fadeIn();
        })
        let boxLogin = $('.box-login');
        boxLogin.on('popbox.close', function () {
            if (success)
                location.reload()
            setTimeout(function () {
                form.find('.hide-on-success').fadeIn()
                form.find('.show-on-success').hide()
                let btn = form.find('button')
                btn.text(btn.data('submittext')).attr('disabled', false)
            }, 500)
        })

        $('#od-close').click(function (e) {
            e.preventDefault()
            $('.box-login .close').click();
        })
    }

    init()
}

let loaded = false
export default function initOpendaysBox(button) {
    if (!loaded) {
        OpendaysPopup()
        loaded = true
    }
    $('#event_id').val(button.data('id')).change()
    $('#participants_count').val(1)
    $('input[name=address]').val('')
    $('input[name=email]').val('')
    $('input[name=phone]').val('')
    $('input[name="participants[1][firstname]"]').val('')
    $('input[name="participants[1][lastname]"]').val('')
    $('input[name=terms1]').attr('checked', false)
    $('input[name=terms2]').attr('checked', false).val('')
    $('input[name=newsletter]').attr('checked', false)
}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/openday.jsx